/**
 * Represents a summary card skeleton component.
 */
export default class SummaryCardSkeleton {
  /**
   * Creates an instance of SummaryCardSkeleton.
   */
  constructor() {
    this.id = 'summaryCardSkeleton';
  }

  /**
   * Gets the HTML element with the specified ID.
   * @returns {HTMLElement} The HTML anchor element.
   */
  getElement() {
    return document.getElementById(this.id);
  }

  /**
   * Returns the HTML representation of the summary card.
   * @returns {string} The HTML string representing the summary card.
   */
  getHtml() {
    return `
            <div data-qa="map-card-skeleton" id=${this.id} class="nhs-c-card--skeleton-summary nhs-mq-card--skeleton-summary-medium">
                <div class="nhs-c-card--skeleton-summary__image nhs-c-card-skeleton__item--animated">
                </div>
                <div class="nhs-c-card--skeleton-summary__body">
                    <div class="nhs-c-card--skeleton-summary__item nhs-c-card-skeleton__item--animated"></div>
                    <div class="nhs-c-card--skeleton-summary__item nhs-c-card-skeleton__item--animated"></div>
                    <div class="nhs-c-card--skeleton-summary__item nhs-c-card-skeleton__item--animated"></div>
                    <div class="nhs-c-card--skeleton-summary__item nhs-c-card-skeleton__item--animated"></div>
                </div>
            </div>
        `;
  }
}
